/**
 * Extracts the canPreviewStatements claim from a JWT access token payload (no signature verification).
 */
export function getCanPreviewStatementsFromToken(token: string | null | undefined): boolean {
  if (token == null || token.trim() === "")
    return false;

  try {
    const payloadBase64 = token.split(".")[1];
    if (!payloadBase64)
      return false;

    const payload = JSON.parse(atob(payloadBase64)) as { canPreviewStatements?: boolean | string };
    return String(payload.canPreviewStatements).toLowerCase() === "true";
  }
  catch {
    return false;
  }
}
